import React from "react";
import { Range, getTrackBackground } from "react-range";

export default class InputRange extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            values: props.values || [props.min, props.max]
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.values[0] !== this.props.values[0] || prevProps.values[1] !== this.props.values[1]) {
            this.setState({
                values: this.props.values
            });
        }
    }

    renderThumb = ({ props, index }) => (
        <div {...props}>
            <div className="input-range__slider" style={{transform: "translateY(-50%) rotate(45deg)", ...(index === 0 && { right: "100%" })}}/>
        </div>
    );

    renderTrack = ({ props, children }) => {
        const { values } = this.state;
        const { min, max } = this.props;
        const background = getTrackBackground({values, colors: ["#c6cacf", "#233654", "#c6cacf"], min, max});
        return (
            <div {...props} className="input-range__track input-range__track--background" style={{ background }}>{children}</div>
        );
    };

    render() {
        return (
            <div className="input-range--wrapper">
                <div className="input-range">
                    <Range step={this.props.step} min={this.props.min} max={this.props.max} values={this.state.values} onChange={this.props.onChange} onFinalChange={this.props.onFinalChange} renderThumb={this.renderThumb} renderTrack={this.renderTrack}/>
                </div>
                <p className="input-range--label">{this.props.minLabel}</p>
                <p className="input-range--label">{this.props.maxLabel}</p>
            </div>
        );
    }
}